export default [
  // { key: 0, label: '简体中文', value: 'zh-CN', currency: '元', money: '￥' },
  { key: 1, label: 'English', value: 'en-US', currency: 'dollar', money: '$' }
  // { key: 2, label: "Spanish", value: "es-ES", currency: "EUR", money: "€" }
  //   { key: 2, label: "Romanian", value: "ro-RO", currency: "RON", money: "L" },
]
